import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c9664ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home h-full bg-primary-50 w-full" }
const _hoisted_2 = { class: "bg-primary-900 sidebar fixed" }
const _hoisted_3 = {
  class: "custom-menu-scrollbar",
  id: "nav"
}
const _hoisted_4 = { class: "bottom-actions absolute block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "inline-block mr-2 margin-y-auto",
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.19734 2.58855L3.76534 1.77699C3.49808 1.68798 3.21349 1.66375 2.93503 1.7063C2.65657 1.74884 2.39221 1.85695 2.16373 2.02172C1.93525 2.18648 1.74919 2.40318 1.62089 2.65396C1.49259 2.90474 1.42571 3.18241 1.42578 3.4641V13.9379C1.42569 14.3112 1.5431 14.675 1.76135 14.9778C1.97961 15.2806 2.28764 15.507 2.64178 15.625L6.19734 16.8099C6.56201 16.9313 6.95622 16.9313 7.32089 16.8099L11.5307 15.4072C11.8953 15.2858 12.2896 15.2858 12.6542 15.4072L15.0862 16.2179C15.3536 16.3069 15.6382 16.3311 15.9167 16.2885C16.1953 16.246 16.4597 16.1378 16.6882 15.9729C16.9167 15.808 17.1027 15.5912 17.231 15.3403C17.3592 15.0894 17.426 14.8117 17.4258 14.5299V4.05699C17.4259 3.68383 17.3087 3.32008 17.0906 3.01728C16.8725 2.71448 16.5646 2.48799 16.2107 2.36988L12.6551 1.18499C12.2902 1.06334 11.8956 1.06334 11.5307 1.18499L7.32 2.58766C6.95533 2.70912 6.56112 2.70912 6.19645 2.58766L6.19734 2.58855Z",
    stroke: "#9AABD3",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.75879 2.77734V16.9996",
    stroke: "#9AABD3",
    "stroke-width": "1.33333",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.0928 1V15.2222",
    stroke: "#9AABD3",
    "stroke-width": "1.33333",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "inline-block margin-y-auto" }, "Mappa", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Logout", -1))
const _hoisted_8 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SultanLogo = _resolveComponent("SultanLogo")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createVNode(_component_SultanLogo, { class: "logo" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MenuButton, {
          to: "/dashboard",
          name: "Bacheca"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/working-sites",
          name: "Cantieri"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/users",
          name: "Dipendenti"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/notifications",
          name: "Notifiche"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/calendar",
          name: "Calendario"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/tools",
          name: "Strumenti"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/reports",
          name: "Report"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/chats",
          name: "Chat"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/settings",
          name: "Impostazioni"
        }),
        _createVNode(_component_MenuButton, {
          class: "mt-2",
          to: "/support",
          name: "Supporto"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SecondaryButton, {
          class: "inline-block bg-white text-primary-200",
          onClick: _ctx.onMap
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_SecondaryButton, {
          class: "block text-white",
          onClick: _ctx.onLogout
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Caricamento..."
        }))
      : _createCommentVNode("", true)
  ]))
}